<style lang="scss" scoped>
    .crowdsource-box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba($black, 0.9);
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transition: opacity $transition-short, visibility $transition-short;

        &.active {
            opacity: 1;
            visibility: visible;
            pointer-events: initial;
        }

        &__content {
            position: relative;
            text-align: center;
            width: 500px;
            font-size: toRem(16px);
            line-height: lh(22px, 16px);
            color: $white;
            background-color: $black;
            border: 1px solid $white;
            padding: 40px;
            margin: 0 25px;
            @include above(md) {
                font-size: toRem(20px);
                line-height: lh(26px, 20px);
            }
        }

        &__close {
            position: absolute;
            top: -30px;
            right: 0;
            transform: translateY(-100%);
            font-weight: 600;
            font-size: toRem(15px);
            line-height: lh(21px, 15px);
            letter-spacing: 11.1px;
            text-transform: uppercase;
            display: flex;
            align-items: center;

            &:after {
                content: '';
                display: block;
                background-image: url('/img/icons/close-white.svg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                width: 18px;
                height: 20px;
                margin-left: 15px;
            }
        }

        &__title {
            font-weight: bold;
            font-size: toRem(20px);

            @include above(md) {
                font-size: toRem(30px);
            }
        }
    }
</style>
<template>
    <div class="crowdsource-box" :class="{active}">
        <div class="crowdsource-box__content">
            <a href="#!" @click.prevent="$emit('close')" class="crowdsource-box__close">Close</a>
            <h3 class="crowdsource-box__title">Collaboration Opportunity</h3>
            <p>
                We don't yet have this data available.
            </p>
            <p>
                Can you help fill in the gaps?
            </p>
            <p>
                Contact us at <a href="mailto:seqgeq@flowjo.com">seqgeq@flowjo.com</a>!
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CrowdsourceBox',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
